import { AuthGuard, CheckPermissionsModes } from "@elit-hair/elit-tools";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { PERMISSIONS } from "@/constants/permissions";
import { NotAuthorizedPage } from "@/pages/not-authorized/-index";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

const CallVolumeSearchSchema = z.object({
    team: z.string().optional(),
    agent: z.string().optional(),
    start: z.string().optional(),
    end: z.string().optional(),
    callPurpose: z.string().optional(),
});

export type CallVolumeSearch = z.infer<typeof CallVolumeSearchSchema>;

export const Route = createFileRoute(APP_ROUTES_FULL.PERFORMANCE_CALL_VOLUME)({
    component: CallVolumeLayout,
    validateSearch: zodValidator(CallVolumeSearchSchema),
    staticData: {
        config: {
            breadcrumb: {
                title: "call_volume",
                to: APP_ROUTES_TO.PERFORMANCE_CALL_VOLUME,
            },
            title: "call_volume",
        },
        permissions: [PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE],
    },
});

function CallVolumeLayout() {
    return (
        <AuthGuard
            required={[PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE, PERMISSIONS.CALL_SVC_ADMIN_BASE]}
            permissionMode={CheckPermissionsModes.ANY}
            fallback={<NotAuthorizedPage />}
        >
            <Outlet />
        </AuthGuard>
    );
}
